import { render, staticRenderFns } from "./VSwitchButton.vue?vue&type=template&id=71db6474&"
import script from "./VSwitchButton.vue?vue&type=script&lang=ts&"
export * from "./VSwitchButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports